"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var Observable_1 = require("rxjs/Observable");
var core_1 = require("@angular/core");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var overview_card_type_1 = require("../../../../../controls/summary-pages/common/model/overview-card-type");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_workflow_service_client_js_1 = require("@synisys/idm-workflow-service-client-js");
var operators_1 = require("rxjs/operators");
var party_provider_service_1 = require("../../../api/party-provider.service");
var meta_knowledge_provider_service_1 = require("../../../api/meta-knowledge-provider.service");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var document_manager_client_1 = require("../../../../../controls/documents/document-manager/service/api/document-manager.client");
var OverviewCustomCalculationFieldsImplService = /** @class */ (function () {
    function OverviewCustomCalculationFieldsImplService(kbService, processService, currentLanguageProvider, partyProviderService, metaKnowledgeProviderService, documentManagerClient) {
        this.kbService = kbService;
        this.processService = processService;
        this.currentLanguageProvider = currentLanguageProvider;
        this.partyProviderService = partyProviderService;
        this.metaKnowledgeProviderService = metaKnowledgeProviderService;
        this.documentManagerClient = documentManagerClient;
    }
    OverviewCustomCalculationFieldsImplService_1 = OverviewCustomCalculationFieldsImplService;
    OverviewCustomCalculationFieldsImplService.addFinalizedDraftOngoing = function (customFields) {
        var finalizedItems = { key: 'ejustice_finalized', participants: ['WFStateID'] };
        var draftItems = { key: 'ejustice_draft', participants: ['WFStateID'] };
        var ongoingItems = { key: 'ejustice_ongoing', participants: ['WFStateID'] };
        customFields.push(finalizedItems);
        customFields.push(draftItems);
        customFields.push(ongoingItems);
    };
    OverviewCustomCalculationFieldsImplService.addPartyDefinitions = function (partyDefinitions, customFields) {
        if (partyDefinitions) {
            if (partyDefinitions.parties) {
                customFields.push({ key: 'ejustice_parties', participants: [partyDefinitions.parties.field] });
            }
            if (partyDefinitions.participants) {
                customFields.push({ key: 'ejustice_participants', participants: [partyDefinitions.participants.field] });
            }
            if (partyDefinitions.advocates) {
                customFields.push({ key: 'ejustice_advocates', participants: [partyDefinitions.advocates.field] });
            }
        }
    };
    OverviewCustomCalculationFieldsImplService.prototype.getCustomFields = function (category, overviewCardType) {
        var customFields = [];
        if (overviewCardType === overview_card_type_1.OverviewCardType.CUSTOM_CARD && this.documentManagerClient) {
            customFields.push({ key: 'ejustice_all_documents_amount', participants: [] });
        }
        if (overviewCardType === overview_card_type_1.OverviewCardType.GROUP_CARD && this.kbService && this.processService) {
            OverviewCustomCalculationFieldsImplService_1.addFinalizedDraftOngoing(customFields);
        }
        var loadPartyDefinitions$ = this.metaKnowledgeProviderService && this.partyProviderService &&
            (overviewCardType === overview_card_type_1.OverviewCardType.MAIN_CARD || overviewCardType === overview_card_type_1.OverviewCardType.SINGLE_ENTITY_CARD) ?
            this.metaKnowledgeProviderService.getPartyDefinitions(category) : Observable_1.Observable.of(null);
        return loadPartyDefinitions$.pipe(operators_1.map(function (partyDefinitions) {
            OverviewCustomCalculationFieldsImplService_1.addPartyDefinitions(partyDefinitions, customFields);
            return customFields;
        }));
    };
    OverviewCustomCalculationFieldsImplService.prototype.calculate = function (customFieldKey, category, rootCategory, overviewCardType, rootEntity, entities) {
        if (!rootEntity) {
            return Observable_1.Observable.of([{ value: '', title: customFieldKey }]);
        }
        switch (customFieldKey) {
            case 'ejustice_parties':
                return this.constructParties(customFieldKey, category, overviewCardType === overview_card_type_1.OverviewCardType.MAIN_CARD ?
                    rootEntity : entities && entities[0], 'getParties', 'parties', 'partyField');
            case 'ejustice_participants':
                return this.constructParties(customFieldKey, category, overviewCardType === overview_card_type_1.OverviewCardType.MAIN_CARD ?
                    rootEntity : entities && entities[0], 'getParticipants', 'participants', 'participantField');
            case 'ejustice_advocates':
                return this.constructParties(customFieldKey, category, overviewCardType === overview_card_type_1.OverviewCardType.MAIN_CARD ?
                    rootEntity : entities && entities[0], 'getAdvocates', 'advocates', 'advocateField');
            case 'ejustice_finalized':
                return this.loadStatesAmount(category, entities, false, true)
                    .pipe(operators_1.map(function (value) { return [{ title: customFieldKey, value: value.toString() }]; }));
            case 'ejustice_draft':
                return this.loadStatesAmount(category, entities, true)
                    .pipe(operators_1.map(function (value) { return [{ title: customFieldKey, value: value.toString() }]; }));
            case 'ejustice_ongoing':
                return this.loadStatesAmount(category, entities, false, false)
                    .pipe(operators_1.map(function (value) { return [{ title: customFieldKey, value: value.toString() }]; }));
            case 'ejustice_all_documents_amount':
                return this.loadDocumentsAmount(rootCategory, rootEntity)
                    .pipe(operators_1.map(function (value) { return [{ title: customFieldKey, value: value.toString() }]; }));
            default:
                return Observable_1.Observable.of(null);
        }
    };
    OverviewCustomCalculationFieldsImplService.prototype.constructParties = function (customFieldKey, category, entity, partyFunction, definitionMainField, definitionPartyField) {
        var currentLanguage$ = this.currentLanguageProvider.getCurrentLanguage();
        return Observable_1.Observable.zip(currentLanguage$, this.metaKnowledgeProviderService.getPartyDefinitions(category), this.partyProviderService[partyFunction](category, entity.getInstanceId(), entity))
            .pipe(operators_1.map(function (_a) {
            var currentLanguage = _a[0], partyDefinitions = _a[1], subEntities = _a[2];
            var result = [];
            if (subEntities && subEntities.length) {
                if (partyDefinitions[definitionMainField]['roleField']) {
                    var partyRoles = new Set(subEntities.map(function (sub) {
                        return sub.getProperty(partyDefinitions[definitionMainField]['roleField']).value;
                    }));
                    Array.from(partyRoles).forEach(function (partyRole) {
                        if (partyRole) {
                            var roleParties = subEntities.filter(function (sub) {
                                return sub.getProperty(partyDefinitions[definitionMainField]['roleField']).value &&
                                    sub.getProperty(partyDefinitions[definitionMainField]['roleField']).value.getId() === partyRole.getId();
                            });
                            if (roleParties && roleParties.length) {
                                var roleName = partyRole.getProperty('name').value instanceof idm_crosscutting_concepts_frontend_1.MultilingualString ?
                                    partyRole.getProperty('name').value.getValue(currentLanguage.getId())
                                    : partyRole.getProperty('name').value;
                                var rolePartiesString = roleParties.map(function (sub) {
                                    return sub.getProperty(partyDefinitions[definitionMainField][definitionPartyField]).value &&
                                        "<div>" + sub.getProperty(partyDefinitions[definitionMainField][definitionPartyField]).value
                                            .getProperty('name').value + "</div>";
                                }).join('');
                                result.push({ title: roleName, value: rolePartiesString, valueIsHtml: true });
                            }
                        }
                    });
                }
                else {
                    var value = subEntities ? subEntities.map(function (sub) {
                        return sub.getProperty(partyDefinitions[definitionMainField][definitionPartyField]).value
                            .getProperty('name').value;
                    }).join('; ') : '';
                    result.push({ title: customFieldKey, value: value });
                }
            }
            return result;
        }));
    };
    OverviewCustomCalculationFieldsImplService.prototype.loadStatesAmount = function (categoryName, entities, loadDrafts, loadFinal) {
        var _this = this;
        return this.kbService.getMetaCategoryByMetaCategoryId(new idm_kb_service_client_js_1.MetaCategoryId(categoryName)).pipe(operators_1.switchMap(function (category) { return _this.processService.getProcessById(category.getWFProcessId()); }), operators_1.switchMap(function (processDto) {
            var draftState = processDto.getInitialStateId();
            if (loadDrafts) {
                var draftAmount_1 = 0;
                if (entities && entities.length) {
                    entities.forEach(function (entity) {
                        return entity.getProperty('WFStateID').value
                            && entity.getProperty('WFStateID').value.getId() === draftState
                            && ++draftAmount_1;
                    });
                }
                return Observable_1.Observable.of(draftAmount_1);
            }
            else if (loadFinal) {
                return Observable_1.Observable.from(_this.processService.getStructure(processDto.getId()))
                    .pipe(operators_1.map(function (process) {
                    var finalStateIds = process.getStates().filter(function (state) { return state.getIsFinal(); }).map(function (state) { return state.getId(); });
                    var finalAmount = 0;
                    if (entities && entities.length && finalStateIds.length) {
                        entities.forEach(function (entity) {
                            return entity.getProperty('WFStateID').value
                                && finalStateIds.indexOf(entity.getProperty('WFStateID').value.getId()) !== -1
                                && ++finalAmount;
                        });
                    }
                    return finalAmount;
                }));
            }
            else {
                return Observable_1.Observable.from(_this.processService.getStructure(processDto.getId()))
                    .pipe(operators_1.map(function (process) {
                    var stateIds = process.getStates().filter(function (state) { return !state.getIsFinal() && state.getId() !== draftState; }).map(function (state) { return state.getId(); });
                    var finalAmount = 0;
                    if (entities && entities.length && stateIds.length) {
                        entities.forEach(function (entity) {
                            return entity.getProperty('WFStateID').value
                                && stateIds.indexOf(entity.getProperty('WFStateID').value.getId()) !== -1
                                && ++finalAmount;
                        });
                    }
                    return finalAmount;
                }));
            }
        }));
    };
    OverviewCustomCalculationFieldsImplService.prototype.loadDocumentsAmount = function (category, rootEntity) {
        var loadDocuments$ = rootEntity && this.documentManagerClient ?
            this.documentManagerClient.loadDocumentsByEntityId(category, rootEntity.getInstanceId(), new idm_de_core_frontend_1.PagingOptions(0, 0)) : Observable_1.Observable.of('0');
        return loadDocuments$.pipe(operators_1.map(function (documents) {
            var value = 0;
            if (documents && documents['folders']) {
                value = Number(documents['allDocumentsCount']);
            }
            return value.toString();
        }));
    };
    var OverviewCustomCalculationFieldsImplService_1;
    OverviewCustomCalculationFieldsImplService = OverviewCustomCalculationFieldsImplService_1 = __decorate([
        core_1.Injectable(),
        __param(0, core_1.Optional()),
        __param(1, core_1.Optional()),
        __param(2, core_1.Optional()),
        __param(3, core_1.Optional()),
        __param(4, core_1.Optional()),
        __param(5, core_1.Optional()),
        __metadata("design:paramtypes", [idm_kb_service_client_js_1.KbService,
            idm_workflow_service_client_js_1.ProcessService,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider,
            party_provider_service_1.PartyProviderService,
            meta_knowledge_provider_service_1.MetaKnowledgeProviderService,
            document_manager_client_1.DocumentManagerClient])
    ], OverviewCustomCalculationFieldsImplService);
    return OverviewCustomCalculationFieldsImplService;
}());
exports.OverviewCustomCalculationFieldsImplService = OverviewCustomCalculationFieldsImplService;
//# sourceMappingURL=overview-custom-calculation-fields-impl.service.js.map